import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconRoute = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <circle cx="6" cy="19" r="2.5" />
    <circle cx="18" cy="5" r="2.5" />
    <path d="M8.5 19H14a3.5 3.5 0 0 0 0-7H10a3.5 3.5 0 0 1 0-7h5.5" />
  </SidebarIconSvg>
);

SidebarIconRoute.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconRoute;
